import { Box } from '@mui/material'
import { Link } from 'react-router-dom'
import logo from '../../../../images/Iso Errepar.png'

function LogoMobile () {
  return (
    <Link to="/dashboard">
      <Box sx={{ mr: 2, display: 'flex' }}>
        <img src={logo} width={35} height={35} />
      </Box>
    </Link>
  )
}

export default LogoMobile
